import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import convert from 'xml-js';

import DeclarationElement from './declaration-el';
import Elements from './elements';

const defaultIndentSize = 2;

const defaultTheme = {
  tagColor: '#d43900',
  textColor: '#333',
  attributeKeyColor: '#2a7ab0',
  attributeValueColor: '#008000',
  separatorColor: '#333',
  commentColor: '#aaa',
  cdataColor: '#1d781d',
  overflowBreak: false,
};

const defaultInvalidXml = <div>Invalid XML!</div>;

const XMLViewer = ({
  xml,
  theme = {},
  indentSize = defaultIndentSize,
  invalidXml = defaultInvalidXml,
  onClick = null,
  ...props
}) => {
  const customTheme = { ...defaultTheme, ...theme };
  let json;
  try {
    json = convert.xml2js(xml, { compact: false, spaces: 0 });
    if (!Array.isArray(json.elements)) {
      return invalidXml;
    }
  } catch {
    return invalidXml;
  }

  return (
    <Box
      sx={muiTheme => ({
        backgroundColor: muiTheme.palette.codeBackground,
        fontSize: 16,
        p: 2,
        lineHeight: '1.5em',
      })}
      {...props}
    >
      {json.declaration && (
        <DeclarationElement theme={customTheme} attributes={json.declaration.attributes} />
      )}
      <Elements
        onClick={onClick}
        elements={json.elements}
        theme={customTheme}
        indentSize={indentSize}
        indentation=""
        xpath=""
      />
    </Box>
  );
};

XMLViewer.propTypes = {
  xml: PropTypes.string.isRequired,
  theme: PropTypes.object,
  indentSize: PropTypes.number,
  invalidXml: PropTypes.node,
  onClick: PropTypes.func,
};

export default XMLViewer;
